var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notification-handler" }, [
    _c(
      "div",
      [
        _c(
          "TransitionGroup",
          {
            staticClass: "notification-handler-container",
            attrs: { tag: "div", name: "notification-transition" }
          },
          _vm._l(_vm.notifications, function(notification) {
            return _c(
              "NotificationBanner",
              _vm._b(
                {
                  key: notification.notifId,
                  ref: "notif" + notification.notifId,
                  refInFor: true,
                  on: { clear: _vm.onClear }
                },
                "NotificationBanner",
                notification,
                false
              )
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }